import {
  alertMessagesArgsConfig,
  collectionArgsConfig,
  collectionFieldArgsConfig,
  getItemIdFromArgsConfig,
} from '../../utils/event_constants';

export const cibilActions = [
  {
    name: 'cibilConsumerReport',
    label: 'Consumer Report & CreditVision Score',
    args: [
      collectionArgsConfig,
      collectionFieldArgsConfig({ name: 'firstNameField', label: 'Select First Name Field' }),
      collectionFieldArgsConfig({ name: 'middleNameField', label: 'Select Middle Name Field' }),
      collectionFieldArgsConfig({ name: 'lastNameField', label: 'Select Last Name Field' }),
      collectionFieldArgsConfig({ name: 'birthDateField', label: 'Select Birth Date Field' }),
      collectionFieldArgsConfig({ name: 'genderField', label: 'Select Gender Field' }),
      collectionFieldArgsConfig({ name: 'panNumberField', label: 'Select PAN Number Field' }),
      collectionFieldArgsConfig({
        name: 'telephoneNumberField',
        label: 'Select Telephone Number Field',
      }),
      collectionFieldArgsConfig({ name: 'lineOneField', label: 'Select Address Line 1 Field' }),
      collectionFieldArgsConfig({ name: 'lineTwoField', label: 'Select Address Line 2 Field' }),
      collectionFieldArgsConfig({ name: 'stateField', label: 'Select State Field' }),
      collectionFieldArgsConfig({ name: 'pinCodeField', label: 'Select Pin Code Field' }),
      ...getItemIdFromArgsConfig,
      collectionFieldArgsConfig({
        name: 'saveResponseField',
        label: 'Select Field to Save Response',
      }),
      ...alertMessagesArgsConfig,
    ],
  },
];
